import useAuth from "./useAuth"

const ROLE_ADMIN = "ROLE_ADMIN"

/**
 * Whether the current user is a platform admin (product.md §4.5).
 * Roles are parsed from the JWT in the auth slice.
 */
export default function useIsAdmin(): boolean {
  const { roles } = useAuth()

  return roles.includes(ROLE_ADMIN)
}
